import { render, staticRenderFns } from "./managePallets.vue?vue&type=template&id=7e7e76c0"
import script from "./managePallets.vue?vue&type=script&lang=js"
export * from "./managePallets.vue?vue&type=script&lang=js"
import style0 from "./managePallets.vue?vue&type=style&index=0&id=7e7e76c0&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports